import audioBookFolders from '../constants/audioBookFolders';

const everestBookCodes = {
  創: 'GEN',
  出: 'EXO',
  利: 'LEV',
  民: 'NUM',
  申: 'DEU',
  書: 'JOS',
  士: 'JDG',
  得: 'RUT',
  撒上: '1SA',
  撒下: '2SA',
  王上: '1KI',
  王下: '2KI',
  代上: '1CH',
  代下: '2CH',
  拉: 'EZR',
  尼: 'NEH',
  斯: 'EST',
  伯: 'JOB',
  詩: 'PSA',
  箴: 'PRO',
  傳: 'ECC',
  歌: 'SNG',
  賽: 'ISA',
  耶: 'JER',
  哀: 'LAM',
  結: 'EZK',
  但: 'DAN',
  何: 'HOS',
  珥: 'JOL',
  摩: 'AMO',
  俄: 'OBA',
  拿: 'JON',
  彌: 'MIC',
  鴻: 'NAM',
  哈: 'HAB',
  番: 'ZEP',
  該: 'HAG',
  亞: 'ZEC',
  瑪: 'MAL',
};

const trimTrailingSlash = value => String(value || '').replace(/\/$/, '');

const useSameOriginForLocalDevelopmentAudio = value => {
  const url = trimTrailingSlash(value);
  if (
    typeof window !== 'undefined'
    && window.location.protocol === 'https:'
    && /^http:\/\/(localhost|127\.0\.0\.1):8300$/i.test(url)
  ) {
    return '/audio';
  }
  return url;
};

const primaryAudioBaseURL = useSameOriginForLocalDevelopmentAudio(
  process.env.REACT_APP_AUDIO_BASE_URL || '/audio'
);

const everestAudioBaseURL = trimTrailingSlash(
  process.env.REACT_APP_EVEREST_AUDIO_BASE_URL || primaryAudioBaseURL
);

const audioExists = async url => {
  const response = await fetch(url, {
    method: 'HEAD',
    cache: 'no-store',
  });

  if (response.ok) return true;
  if (response.status === 404) return false;

  throw new Error(`Audio server returned ${response.status}`);
};

export const resolveChapterAudio = async ({ book, chapter }) => {
  const folder = audioBookFolders[book];
  if (!folder || !primaryAudioBaseURL) return null;

  const chapterNumber = String(chapter).padStart(3, '0');
  const primaryURL = `${primaryAudioBaseURL}/${folder}/${chapterNumber}.mp3`;

  if (await audioExists(primaryURL)) {
    return { url: primaryURL, source: 'local' };
  }

  const everestCode = everestBookCodes[book];
  if (!everestCode || !everestAudioBaseURL) return null;

  const everestFile = `${everestCode}_${chapterNumber}_ck7_ef10.mp3`;
  const everestURL = `${everestAudioBaseURL}/${folder}/${everestFile}`;

  if (await audioExists(everestURL)) {
    return { url: everestURL, source: 'everest' };
  }

  return null;
};
